<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form @keyup.enter.native="searchQuery" layout="inline">
        <a-row :gutter="24">
          <!-- <j-select-device-class :multiple="false" placeholder="请选择设备类型" v-model="model.devClassId" /> -->
          <a-col :md="6" :sm="12">
            <a-form-item label="设备类型">
              <j-tree-select
                @change="searchQuery"
                dict="`iwt-wf`.dev_class,type_name,id"
                pidValue="-1"
                placeholder="请选择设备类型"
                ref="treeSelect"
                v-model="queryParam.devClassCode"
              ></j-tree-select>
              <!-- <j-select-device-class :multiple="false" placeholder="请选择设备类型" v-model="queryParam.devClassId" /> -->
              <!-- <a-input allowClear placeholder="请输入保养计划名称" v-model="queryParam.devClassId" /> -->
            </a-form-item>
          </a-col>

          <a-col :md="6" :sm="8">
            <span class="table-page-search-submitButtons" style="float: left;overflow: hidden;">
              <a-button @click="searchQuery" icon="search" type="primary">查询</a-button>
              <a-button @click="searchReset" icon="reload" style="margin-left: 8px" type="primary">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" icon="plus" type="primary">新增</a-button>
      <a-button @click="handleExportXls('保养标准库')" icon="download" type="primary">导出</a-button>
      <a-upload
        :action="importExcelUrl"
        :headers="tokenHeader"
        :multiple="false"
        :showUploadList="false"
        @change="handleImportExcel"
        name="file"
      >
        <a-button icon="import" type="primary">导入</a-button>
      </a-upload>
      <!-- 高级查询区域 -->
      <j-super-query :fieldList="superFieldList" @handleSuperQuery="handleSuperQuery" ref="superQueryModal"></j-super-query>
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item @click="batchDel" key="1">
            <a-icon type="delete" />删除
          </a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px">
          批量操作
          <a-icon type="down" />
        </a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择
        <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
        <a @click="onClearSelected" style="margin-left: 24px">清空</a>
      </div>

      <a-table
        :columns="columns"
        :customRow="customRowRender"
        :dataSource="dataSource"
        :loading="loading"
        :pagination="ipagination"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        :scroll="{x:true}"
        @change="handleTableChange"
        bordered
        class="j-table-force-nowrap"
        ref="table"
        rowKey="id"
        size="middle"
      >
        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text">
          <span style="font-size: 12px;font-style: italic;" v-if="!text">无图片</span>
          <img
            :src="getImgView(text)"
            alt
            height="25px"
            style="max-width:80px;font-size: 12px;font-style: italic;"
            v-else
          />
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span style="font-size: 12px;font-style: italic;" v-if="!text">无文件</span>
          <a-button :ghost="true" @click="downloadFile(text)" icon="download" size="small" type="primary" v-else>下载</a-button>
        </template>

        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">编辑</a>

          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">
              更多
              <a-icon type="down" />
            </a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a @click="handleDetail(record)">详情</a>
              </a-menu-item>
              <a-menu-item>
                <a-popconfirm @confirm="() => handleDelete(record.id)" title="确定删除吗?">
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>
      </a-table>
    </div>

    <dev-maintenance-stl-modal @ok="modalFormOk" ref="modalForm" />
  </a-card>
</template>

<script>

  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import DevMaintenanceStlModal from './modules/DevMaintenanceStlModal'
  import '@/assets/less/TableExpand.less'

  export default {
    name: "DevMaintenanceStlList",
    mixins: [JeecgListMixin],
    components: {
      DevMaintenanceStlModal
    },
    data () {
      return {
        description: '保养项目库管理页面',
        queryParam: {},
        // 表头
        columns: [
          {
            title: '保养标准',
            align: "center",
            dataIndex: 'maintenanceName'
          },
          {
            title: '设备类型',
            align: "center",
            dataIndex: 'typeName'
          },

          {
            title: '说明',
            align: "center",
            dataIndex: 'content'
          },

          {
            title: '操作',
            dataIndex: 'action',
            align: "center",
            fixed: "right",
            width: 147,
            scopedSlots: { customRender: 'action' },
          }
        ],
        url: {
          list: "/maintenance/devMaintenanceStl/list",
          delete: "/maintenance/devMaintenanceStl/delete",
          deleteBatch: "/maintenance/devMaintenanceStl/deleteBatch",
          exportXlsUrl: "/maintenance/devMaintenanceStl/exportXls",
          importExcelUrl: "maintenance/devMaintenanceStl/importExcel",

        },
        dictOptions: {},
        superFieldList: [],
      }
    },
    created () {
      this.getSuperFieldList();
    },
    computed: {
      importExcelUrl: function () {
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      }
    },
    methods: {
      initDictConfig () {
      },
      getSuperFieldList () {
        let fieldList = [];
        fieldList.push({ type: 'string', value: 'maintenanceName', text: '保养标准', dictCode: '' })
        fieldList.push({ type: 'string', value: 'devClassId', text: '设备类型', dictCode: '' })
        fieldList.push({ type: 'string', value: 'devModelId', text: '设备型号', dictCode: '' })
        fieldList.push({ type: 'string', value: 'content', text: '说明', dictCode: '' })
        fieldList.push({ type: 'string', value: 'tenantId', text: '租户标识', dictCode: '' })
        fieldList.push({ type: 'string', value: 'orgId', text: '公司标识', dictCode: '' })
        fieldList.push({ type: 'string', value: 'isDelete', text: 'isDelete', dictCode: '' })
        this.superFieldList = fieldList
      }
    }
  }
</script>
<style scoped>

  @import '~@assets/less/common.less';

</style>